import { useEffect } from "react";
import { useDispatch } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import { removeCookies } from "../../../utils";
import { clearUserAction } from "../../../redux/actions/userActions/userActions";

const LogOutAuth = () => {
  const dispatch = useDispatch();

  const handleLogOut = async () => {
    await removeCookies("accessToken");
    dispatch(clearUserAction());
  };

  useEffect(() => {
    handleLogOut();
  }, []);

  return (
    <>
      <SiteTitle title="خروج از حساب کاربری" />

      <div className="text-center my-5">
        <h1>
          <i className="la la-sign-out-alt fa-4x" />
        </h1>
        <h3>لطفا منتظر بمانید!</h3>
        <p>شما درحال خروج از حساب کاربری می باشید</p>
      </div>
    </>
  );
};

export default LogOutAuth;
